export default {
  id: 'conclusion/TREATMENTS/v1',
  formSchema: {
    title: 'encounter:widget.conclusion.treatments',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.conclusion.treatments',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
